module.exports = __webpack_public_path__ + "static/media/nulogo.c7339c9b.png";